import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import TextEditorButton from '../text-editor-button';

export default function createBlockTypeButton({ blockType, content: Content, tooltipText }) {
  return class BlockTypeButton extends Component {
    static propTypes = {
      isBlockType: PropTypes.func.isRequired,
      toggleBlockType: PropTypes.func.isRequired,
      className: PropTypes.string,
    };

    isActive = () => this.props.isBlockType(blockType);
    handleClick = () => this.props.toggleBlockType(blockType);

    render() {
      const {
        isBlockType, // eslint-disable-line no-unused-vars
        toggleBlockType, // eslint-disable-line no-unused-vars
        className,
        ...buttonProps
      } = this.props;
      return (
        <TextEditorButton
          className={classNames(className, `text-editor__${blockType}-button`)}
          onClick={this.handleClick}
          isActive={this.isActive()}
          icon={Content}
          tooltipText={tooltipText}
          {...buttonProps}
        />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/utils/create-block-type-button.js